<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="anchorDate">NTP Date</label>
                    <wj-input-date id="anchorDate" [(ngModel)]="anchorDate" name="anchorDate"></wj-input-date>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="txbxName">Days to Add</label>
                    <input id="txbxName" type="number" class="form-control" [(ngModel)]="days" name="days" autocomplete="off" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="calcDate">Calculated Completion Date</label>
                    <wj-input-date id="calcDate" [value]="calcDate" name="calcDate" [isDisabled]="true"></wj-input-date>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
